import React from "react";
import { useTheme } from "@mui/material/styles";

const StatusInProgressIcon = () => {
  const theme = useTheme();

  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9" cy="9" r="8.5" fill={theme.palette.info[500]} stroke={theme.palette.info[300]}/>
      <circle cx="9" cy="9" r="3" fill={theme.palette.system[0]}/>
    </svg>
  );
};

export default StatusInProgressIcon;
